import { ClickAndCollectIcon, FulfilmentCircle } from '@components/icons'
import { FC } from 'react'

interface Props {
  inventory: number
}

const ClickAndCollect: FC<Props> = ({
  inventory,
}) => {
  return (
    // remove border-b, mb-3 from class
    <div className="flex flex-col justify-between mt-4 border-ui-grey-25">
      <div className="flex items-center">
        <ClickAndCollectIcon />
        <div className="flex w-full justify-between">
          <div className="flex items-center">
            <div className="text-label font-bold text-text-subdued pl-0.6">
              Deliver to Store
            </div>
            <div className="ml-2">
              {inventory > 0 ? (
                <FulfilmentCircle fill="#67CE67" />
              ) : (
                <FulfilmentCircle fill="#EB001B" />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClickAndCollect
